import size from "../sizes";

export default [
  {
    id: `material`,
    title: `Крой и качество материала`,
    content: {
      description: `
        <p>Женственный покрой декольте в сочетании с отсутствующим рукавом - делает это платье настоящей находкой для летних прогулок. На бедрах располагаются удобные карманы. Все швы выполнены очень аккуратно, за счет чего платье без рукавов идеально сидит по фигуре. Слегка расклешено к низу.</p>
      `
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `
        <p>
          Способ печати - сублимация. Принт становится частью ткани и не чувствуется на ощупь. Картинка получается яркой и сочной. Изображение не стирается, не выцветает и не трескается.
        </p>
        <p>Можно стирать в машинке. Гладить, желательно, на изнанку.</p>
      `
    }
  },
  {
    id: `size`,
    title: `Размерная сетка`,
    content: {
      table: size[`sleeveless_dress`],
      sizeInfo: `sleeveless_dress`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
